"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BasicNode_1 = require("./BasicNode");
const types_1 = require("../types");
const ParallelNodeValidation_1 = require("../validations/ParallelNodeValidation");
class ParallelNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.Parallel };
    if (props.type !== types_1.NODE_TYPES.Parallel)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let defaultValue = {
      branches: []
    };
    if (nodeData) {
      return nodeData;
    }
    return defaultValue;
  }
  serialize(uiData) {
    return uiData;
  }
  getAttachedApis(selectedResource) {
    return this.getAttachedApisFromParent(selectedResource);
  }
  async getAvailableResources() {
    return [];
  }
  validate() {
    return new ParallelNodeValidation_1.ParallelNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.ParallelNode = ParallelNode;
//# sourceMappingURL=ParallelNode.js.map
